var _defs, _g, _g2, _g3, _g4, _g5, _g6, _circle, _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 64,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M104-163H24A24.07,24.07,0,0,0,0-139v80A24.07,24.07,0,0,0,24-35h80a24.07,24.07,0,0,0,24-24v-80A24.07,24.07,0,0,0,104-163ZM120-59a16,16,0,0,1-16,16H24A16,16,0,0,1,8-59v-80a16,16,0,0,1,16-16h80a16,16,0,0,1,16,16Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 209,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M64-115A16,16,0,0,0,48-99,16,16,0,0,0,64-83,16,16,0,0,0,80-99,16,16,0,0,0,64-115Zm0,24a8,8,0,0,1-8-8,8,8,0,0,1,8-8,8,8,0,0,1,8,8A8,8,0,0,1,64-91Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M84-63H44A16,16,0,0,1,28-79v-40a16,16,0,0,1,16-16H84a16,16,0,0,1,16,16v40A16,16,0,0,1,84-63ZM44-127a8,8,0,0,0-8,8v40a8,8,0,0,0,8,8H84a8,8,0,0,0,8-8v-40a8,8,0,0,0-8-8Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: -117,
    r: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 27.5,
    cy: 121.5,
    r: 137.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#f2a454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#f05c3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c22f86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#6666ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#5c6cb2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 27.5,
    cy: -41.5,
    r: 148.5,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 13.87,
    cy: 303.38,
    r: 185.63,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 13.87,
    cy: -22.62,
    r: 185.63,
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 121.5,
    r: 137.5,
    fill: "url(#a)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: -41.5,
    r: 148.5,
    fill: "url(#d)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.87,
    cy: 303.38,
    r: 185.63,
    fill: "url(#f)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: -41.5,
    r: 148.5,
    fill: "url(#d)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: -41.5,
    r: 148.5,
    fill: "url(#d)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.87,
    cy: -22.62,
    r: 185.63,
    fill: "url(#j)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 46,
    r: 5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64,48A16,16,0,1,0,80,64,16,16,0,0,0,64,48Zm0,24a8,8,0,1,1,8-8A8,8,0,0,1,64,72Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    x: 32,
    y: 32,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 8,
    rx: 12,
    ry: 12
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/ig.e395727e3fe377a1af7a0323e784068e.svg";
export { ForwardRef as ReactComponent };